import { render, staticRenderFns } from "./Cover.vue?vue&type=template&id=2d8be4bc&"
import script from "./Cover.vue?vue&type=script&lang=js&"
export * from "./Cover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d8be4bc')) {
      api.createRecord('2d8be4bc', component.options)
    } else {
      api.reload('2d8be4bc', component.options)
    }
    module.hot.accept("./Cover.vue?vue&type=template&id=2d8be4bc&", function () {
      api.rerender('2d8be4bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Authentication/SignUp/Cover.vue"
export default component.exports